import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeContextProvider } from "./context/ThemeContext";
import { InitialApp } from "./initializeApp";

export const NotWorking = () => {
  return (
    <div dir="rtl" style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      <h4>سامانه درحال حاضر در دسترس نمی باشد لطفا بعدا مراجعه فرمایید.</h4>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const item = await InitialApp();
if (item) {
  root.render(
    // <React.StrictMode>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>,
    // </React.StrictMode>,
  );
} else {
  root.render(<NotWorking />);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
